import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { OnboardingAxios, IAMAxios } from "../../API";
import authSlice from "../../store/auth/authSlice";
import { POINT_TYPE } from "../Enum";
import { SelectDropdown, TextAreaInput, TextInput } from "../inputs";
import Checkbox from "../inputs/Checkbox";
import CdxModal from '../modal/CdxModal';

const ProfileForm = (props) => {
  const dispatch = useDispatch();

  const profileConfig = useSelector((state) => state.auth.profileConfig);
  const loggedInUser = useSelector((state) => state.auth.loggedInUser);
  const [modalVisible, setModalVisible] = useState(false);

  const [userProfileDataLocal, setUserProfileDataLocal] = useState({
    ...profileConfig.profileData,
  });
  const [userProfile, setUserProfile] = useState({});
  const [profileFormSubmit, setProfileFormSubmit] = useState(false);
  let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };
  const regionsList = [{ value: 2, label: 'USI' }, { value: 1, label: 'US' }];
  const regionsOptions = [{ value: "USI", label: 'USI' }, { value: "US", label: 'US' }];

  useEffect(() => {
    setUserProfile(userProfileDataLocal.userProfile);
  }, [userProfileDataLocal]);

  useEffect(() => {
    setProfilePictureUrl(loggedInUser.profileImage);
  }, []);

  const handleFieldChange = (e, field) => {
    console.log(field);
    console.log(e.target.value);
    var temp = JSON.parse(JSON.stringify(userProfileDataLocal));
    var index = temp.userProfileMetaData
      .map(function (k) {
        return k.value;
      })
      .indexOf(field);
    temp.userProfileMetaData[index]["answer"] = e.target.value;
    setUserProfileDataLocal(temp);
  };

  const handleProfileData = (field, e) => {
    var temp = JSON.parse(JSON.stringify(userProfile));
    temp[field] = e.target.value;
    setUserProfile(temp);
  };

  const handleRegionChange = (e) => {
    var temp = JSON.parse(JSON.stringify(userProfile));
    let reg = regionsList.find((x) => x.label == e.target.value);
    console.log("reg", reg);

    temp['geographyId'] = reg.value;
    temp['geography'] = reg.label;
    setUserProfile(temp);
  };


  const handleCheckBoxChange = (e, item, option, optionIndex) => {
    var localFlag = e.target.checked;
    var temp = JSON.parse(JSON.stringify(userProfileDataLocal));
    var index = temp.userProfileMetaData
      .map(function (k) {
        return k.value;
      })
      .indexOf(item.value);
    var tempStr = [];
    if (temp.userProfileMetaData[index]["answer"])
      tempStr = temp.userProfileMetaData[index]["answer"].split(",");
    if (item.valueType === 3) {
      var options = JSON.parse(temp.userProfileMetaData[index]["options"]);
      options[optionIndex].forEach((option) => {
        var strIndex = tempStr.indexOf(option);
        if (strIndex >= 0) tempStr.splice(strIndex, 1);
      });
      if (localFlag) {
        tempStr.push(option);
      }
    } else {
      if (localFlag) tempStr.push(option);
      else {
        var strIndex = tempStr.indexOf(option);
        tempStr.splice(strIndex, 1);
      }
    }
    temp.userProfileMetaData[index]["answer"] = tempStr.join();
    setUserProfileDataLocal(temp);
  };


  const [isSaving, setIsSaving] = useState(false);
  const updateProfile = () => {
    setIsSaving(true);
    var dataList = [];
    setProfileFormSubmit(true);

    if (userProfile.firstName == "" || userProfile.lastName == "" || userProfile.portfolio == "" || userProfile.location == "" || userProfile.industry == "" || userProfile.offering == "") {
      dispatch(authSlice.actions.setProfilePage(1));
      return;
    }

    let temp1 = userProfileDataLocal.userProfileMetaData.filter(x => x.category == "Basic Profile" &&
      (x.answer == "" || x.answer == null || x.answer == undefined)
    );

    if (temp1.length > 0) {
      dispatch(authSlice.actions.setProfilePage(1));
      return;
    }

    let temp2 = userProfileDataLocal.userProfileMetaData.filter(x => x.category == "About me" &&
      (x.answer == "" || x.answer == null || x.answer == undefined)
    );

    if (temp2.length > 0) {
      dispatch(authSlice.actions.setProfilePage(2));
      return;
    }

    let temp3 = userProfileDataLocal.userProfileMetaData.filter(x => x.category == "Communities of Interest" &&
      (x.answer == "" || x.answer == null || x.answer == undefined)
    );

    if (temp3.length > 0) {
      dispatch(authSlice.actions.setProfilePage(3));
      return;
    }

    userProfileDataLocal.userProfileMetaData.forEach((element) => {
      var data = {
        offeringId: loggedInUser.offeringId,
        userId: loggedInUser.userId,
        profileKey: element.profileKey,
        answer: element.answer,
      };
      dataList.push(data);
    });
    var requestData = {
      requestModel: dataList,
      message: messagePoint,
      isBackgroundJob: false,
    };

    OnboardingAxios.put("UserProfile/updateuserprofile", requestData)
      .then(function (response) {
        if (profilePictureFile != null) {
          let profiledata = response;
          profiledata = new FormData();
          profiledata.set("email", userProfile.email);
          profiledata.append('profileImage', profilePictureFile);
          profiledata.set("firstName", userProfile.firstName);
          profiledata.set("lastName", userProfile.lastName);
          profiledata.set("portfolio", userProfile.portfolio);
          profiledata.set("location", userProfile.location);
          profiledata.set("industry", userProfile.industry);
          profiledata.set("offering", userProfile.offering);
          profiledata.set("geographyId", regionsList.find(x => x.label == userProfile.geography).value);
          profiledata.set("geography", userProfile.geography);

          IAMAxios.put("User/updateuser", profiledata)
            .then(function (response) {
              if (response && response.data) {
                let profileUrl = "";
                if (response.data.profileImage !== null && response.data.profileImage !== undefined && response.data.profileImage !== "") {
                  profileUrl = response.data.profileImage;
                }
                OnboardingAxios.put("OfferingUsers/updateprofileimageurl", {
                  offeringUserId: loggedInUser.offeringUserId,
                  profileImageUrl: profileUrl,
                  geographyId: response.data.geographyId == 0 ? 1 : response.data.geographyId,
                  geography: response.data.geography,
                  firstName: userProfile.firstName,
                  lastName: userProfile.lastName
                })
                  .then(function (res) {
                    dispatch(authSlice.actions.setProfileImage(profileUrl));
                    OnboardingAxios.get(
                      "UserProfile/getuserprofile/" +
                      loggedInUser.userId +
                      "/" +
                      loggedInUser.offeringId
                    )
                      .then(function (response) {
                        dispatch(authSlice.actions.setUserProfileData(response.data));
                      })
                      .catch(function (error) {
                        console.log("error: " + error);
                      });
                    getUserInformation();
                    dispatch(authSlice.actions.refreshProfile());
                    dispatch(authSlice.actions.hideProfileForm());
                    setIsSaving(false);
                  })
                  .catch(function (error) {
                    console.log("error: " + error);
                    dispatch(authSlice.actions.refreshProfile());
                    dispatch(authSlice.actions.hideProfileForm());
                  });
              }
            })
            .catch(function (error) {
              console.log("error: " + error);
              dispatch(authSlice.actions.refreshProfile());
              dispatch(authSlice.actions.hideProfileForm());
            });
        }
        else {
          let profiledata = response;
          profiledata = new FormData();
          profiledata.set("email", userProfile.email);
          profiledata.set("firstName", userProfile.firstName);
          profiledata.set("lastName", userProfile.lastName);
          profiledata.set("portfolio", userProfile.portfolio);
          profiledata.set("location", userProfile.location);
          profiledata.set("industry", userProfile.industry);
          profiledata.set("offering", userProfile.offering);
          profiledata.set("geographyId", regionsList.find(x => x.label == userProfile.geography).value);
          profiledata.set("geography", userProfile.geography);

          IAMAxios.put("User/updateuser", profiledata)
            .then(function (response) {
              if (response && response.data) {
                let profileUrl = "";
                if (response.data.profileImage !== null && response.data.profileImage !== undefined && response.data.profileImage !== "") {
                  profileUrl = response.data.profileImage;
                }
                OnboardingAxios.put("OfferingUsers/updateprofileimageurl", {
                  profileImageUrl: profileUrl,
                  offeringUserId: loggedInUser.offeringUserId,
                  geographyId: response.data.geographyId == 0 ? 1 : response.data.geographyId,
                  geography: response.data.geography,
                  firstName: userProfile.firstName,
                  lastName: userProfile.lastName
                })
                  .then(function (res) {
                    //dispatch(authSlice.actions.setProfileImage(profileUrl));
                    OnboardingAxios.get(
                      "UserProfile/getuserprofile/" +
                      loggedInUser.userId +
                      "/" +
                      loggedInUser.offeringId
                    )
                      .then(function (response) {
                        dispatch(authSlice.actions.setUserProfileData(response.data));
                      })
                      .catch(function (error) {
                        console.log("error: " + error);
                      });
                    getUserInformation();
                    dispatch(authSlice.actions.refreshProfile());
                    dispatch(authSlice.actions.hideProfileForm());
                  })
                  .catch(function (error) {
                    console.log("error: " + error);
                    dispatch(authSlice.actions.refreshProfile());
                    dispatch(authSlice.actions.hideProfileForm());
                  });
              }
            })
            .catch(function (error) {
              console.log("error: " + error);
              dispatch(authSlice.actions.refreshProfile());
              dispatch(authSlice.actions.hideProfileForm());
            });
        }
      })
      .catch(function (error) {
        console.log("error: " + error);
        dispatch(authSlice.actions.refreshProfile());
        dispatch(authSlice.actions.hideProfileForm());
      });
  };

  const [profilePictureFile, setProfilePictureFile] = useState(null);
  const [profilePictureName, setProfilePictureName] = useState("");
  const [profilePictureErrorText, setProfilePictureErrorText] = useState("");
  const [profilePictureUrl, setProfilePictureUrl] = useState("");
  const profilePictureSelectHandler = async (file) => {
    let currentFile = Array.from(file.target.files);
    if (currentFile && currentFile.length > 0) {
      if (!currentFile[0].type.includes("image")) {
        setProfilePictureErrorText(
          "Only image files less than 2MB size are supported"
        );
        return;
      }
      const fileSize = Math.round(currentFile[0].size / 1024);
      if (fileSize >= 2049) {
        setProfilePictureErrorText(
          "Profile picture size exceeds the max limit of 2MB."
        );
        return;
      } else {
        setProfilePictureErrorText("");
      }

      setProfilePictureName(currentFile[0].name);
      setProfilePictureFile(currentFile[0]);
      setProfilePictureUrl(URL.createObjectURL(currentFile[0]));
    }
  };

  const uploadProfilePicture = () => {
    document.getElementById("uploadProfilePicture").click();
  };

  const removeProfilePicture = () => {
    setProfilePictureUrl("");
    setProfilePictureFile(null);
    OnboardingAxios.put("OfferingUsers/updateprofileimageurl", {
      offeringUserId: loggedInUser.offeringUserId,
      profileImageUrl: "",
      firstName: userProfile.firstName,
      lastName: userProfile.lastName,
      geography: userProfile.geography,
      geographyId: 1
    })
      .then(function (res) {
        dispatch(authSlice.actions.setProfileImage(""));
        getUserInformation();
      })
      .catch(function (error) {
        console.log("error: " + error);
      });
  };

  const getUserInformation = () => {
    OnboardingAxios.get(
      "OfferingUsers/getofferinguserbyemail/" + loggedInUser.offeringId + "/" + userProfile.email + "/" + loggedInUser.teamId
    )
      .then(function (response) {
        dispatch(authSlice.actions.login(response.data));

        OnboardingAxios.get('OfferingUsers/getuserpoints/' + loggedInUser.offeringUserId)
          .then(function (response) {
            let data = response.data;
            dispatch(
              authSlice.actions.setPoints({
                currentLevel: data.currentLevel,
                currentRank: data.currentRank,
                teamRank: data.teamRank,
                pointsToNextBadge: data.pointsToNextBadge,
                totalPoints: data.totalPoints,
                experiencePoints: (data.points.find(x => x.pointsType == POINT_TYPE.experience) ? data.points.find(x => x.pointsType == POINT_TYPE.experience).points : 0) || 0,
                bonusPoints: (data.points.find(x => x.pointsType == POINT_TYPE.bonus) ? data.points.find(x => x.pointsType == POINT_TYPE.bonus).points : 0) || 0,
              })
            );
          });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  return (
    <>
      <Modal
        show={profileConfig && profileConfig.showProfileForm}
        backdrop="static"
        fullscreen={true}
        onHide={() => {
          dispatch(authSlice.actions.hideProfileForm());
        }}
        keyboard={false}
        className={"profile-form-modal " + 'step-' + profileConfig.profileFormPage}
      >
        <Modal.Header>
          <div className="branding">
            <Link to="/">
              <div className="logo-image"> </div>
            </Link>
            <div className="logo-text"></div>
            <div className="branding-glow"></div>
          </div>
          <div>
            <button
              value="Save"
              className="save-profile-form cdx-btn"
              onClick={updateProfile}
            >
              {isSaving ? <>Saving </> : <>Save</>}
            </button>
            <button
              value="Discard"
              className="discard-profile-form cdx-btn"
              onClick={() => {
                dispatch(authSlice.actions.hideProfileForm());
              }}
            >
              Discard
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="dialog-profile-wrapper">
            {profileConfig.profileFormPage === 1 && (
              <div className="profile-title build-profile">
                Build Your profile
              </div>
            )}
            {(profileConfig.profileFormPage === 2 ||
              profileConfig.profileFormPage === 3) && (
                <div className="profile-title more-about-me">
                  More about me...
                </div>
              )}
            <div className="profile-content">
              {profileConfig.profileFormPage === 1 && (
                <>
                  <div className="profile-content-wrapper">
                    <>
                      <div className="basic-profile row">
                        <div className="left-panel col ">
                          <TextInput
                            label="First Name"
                            value={userProfile.firstName}
                            onChange={(e) => { handleProfileData("firstName", e) }}
                          />
                          {userProfile.firstName == "" &&
                            <div className="errorMsgText onboardingErrorMsg mt-0"
                            >
                              This field is required
                            </div>}
                          <TextInput
                            label="Last Name"
                            value={userProfile.lastName}
                            onChange={(e) => { handleProfileData("lastName", e) }}
                          />
                          {userProfile.lastName == "" &&
                            <div className="errorMsgText onboardingErrorMsg mt-0"
                            >
                              This field is required
                            </div>}
                          <TextInput
                            label="Email Id"
                            readOnly
                            value={userProfile.email}
                          />
                          <TextInput
                            label="Offering Portfolio"
                            value={userProfile.portfolio}
                            onChange={(e) => { handleProfileData("portfolio", e) }}
                          />
                          {userProfile.portfolio == "" &&
                            <div className="errorMsgText onboardingErrorMsg mt-0"
                            >
                              This field is required
                            </div>}
                        </div>
                        <div className="center-panel col">
                          {/* <div className="w-100 line-wrapper">
                                                    <div className="link-line w-100"></div>
                                                    <div className="link-line w-100"></div>
                                                    <div className="link-line w-100"></div>
                                                    <div className="link-line w-100"></div>
                                                </div> */}
                          {(profilePictureUrl == null ||
                            profilePictureUrl == "" ||
                            profilePictureUrl == undefined ||
                            profilePictureUrl == "NA") && (
                              <div className="profile-picture-initials">
                                {userProfile.firstName && userProfile.lastName && userProfile.firstName[0].toUpperCase() + "" + userProfile.lastName[0].toUpperCase()}
                              </div>
                            )}

                          {profilePictureUrl !== null &&
                            profilePictureUrl !== "" &&
                            profilePictureUrl !== undefined && profilePictureUrl !== "NA" && (
                              <div
                                className="profile-picture-image"
                                style={{
                                  content: "url('" + profilePictureUrl + "')",
                                }}
                              ></div>
                            )}

                          <div className="profile-actions">
                            <div>
                              {profilePictureUrl !== null &&
                                profilePictureUrl !== "" &&
                                profilePictureUrl !== undefined && profilePictureUrl !== "NA" &&

                                <div
                                  className="action-button outline"
                                  title="Remove Your Photo"
                                  onClick={() => { setModalVisible(true); }}>
                                  <div className="deleteIcon" />
                                </div>
                              }
                            </div>

                            <div
                              className="action-button outline"
                              onClick={uploadProfilePicture}
                              title="Upload Your Photo"
                            >
                              <div className="cameraIcon" />
                              <input
                                className="file-upload"
                                id="uploadProfilePicture"
                                type="file"
                                onChange={(e) => {
                                  profilePictureSelectHandler(e);
                                }}
                                onClick={(event) => {
                                  event.target.value = null
                                }}
                                accept="image/*"
                              />
                            </div>

                          </div>
                          {/* <div className="w-100">
                                                    <div className="link-line w-100"></div>
                                                    <div className="link-line w-100"></div>
                                                    <div className="link-line w-100"></div>
                                                    <div className="link-line w-100"></div>
                                                </div> */}
                        </div>
                        <div className="right-panel col">
                          <TextInput
                            label="Offering"
                            value={userProfile.offering}
                            onChange={(e) => { handleProfileData("offering", e) }}
                          />
                          {userProfile.offering == "" &&
                            <div className="errorMsgText onboardingErrorMsg mt-0"
                            >
                              This field is required
                            </div>}
                          <TextInput
                            label="Location"
                            value={userProfile.location}
                            onChange={(e) => { handleProfileData("location", e) }}
                          />
                          {userProfile.location == "" &&
                            <div className="errorMsgText onboardingErrorMsg mt-0"
                            >
                              This field is required
                            </div>}
                          <TextInput
                            label="Industry"
                            value={userProfile.industry}
                            onChange={(e) => { handleProfileData("industry", e) }}
                          />
                          {userProfile.industry == "" &&
                            <div className="errorMsgText onboardingErrorMsg mt-0"
                            >
                              This field is required
                            </div>}
                          <SelectDropdown
                            label="Region/Geography"
                            options={regionsOptions}
                            className="col-md"
                            value={userProfile.geography}
                            onChange={(e) => handleRegionChange(e)}
                          />

                          {/* <TextInput
                            label="Region/Geography"
                            readOnly
                            value={userProfile.geography}
                            onChange={(e) => { handleProfileData("geography", e) }}
                          /> */}
                        </div>
                      </div>
                    </>
                  </div>
                  <div className="profile-bottom-content-wrapper">
                    <div className="profile-link"></div>

                    <div className="row px2">
                      {userProfileDataLocal &&
                        userProfileDataLocal.userProfileMetaData.length > 0 &&
                        userProfileDataLocal.userProfileMetaData
                          .filter((x) => x.category == "Basic Profile")
                          .map((item, index) => {
                            return (
                              <div key={`asacas${index}`} className="col mt-auto" style={{ position: "relative" }}>
                                <TextAreaInput
                                  className="more-about-me-input"
                                  label={item.value}
                                  maxLength="500"
                                  onChange={(e) => {
                                    handleFieldChange(e, item.value);
                                  }}
                                  value={item.answer}
                                />
                                {profileFormSubmit &&
                                  (item.answer == "" ||
                                    item.answer == null ||
                                    item.answer == undefined) && (
                                    <div className="errorMsgText onboardingErrorMsg position-absolute"
                                    >
                                      This field is required
                                    </div>
                                  )}
                              </div>
                            );
                          })}
                    </div>
                  </div>
                </>
              )}

              {profileConfig.profileFormPage === 2 && (
                <div className="profile-content-wrapper">
                  <div className="profile-body">
                    <div className="more-about-me-content profile-form-body">
                      {userProfileDataLocal &&
                        userProfileDataLocal.userProfileMetaData.length > 0 &&
                        userProfileDataLocal.userProfileMetaData
                          .filter((x) => x.category == "About me")
                          .map((item) => {
                            return (
                              <>
                                <div style={{ position: "relative" }}>
                                  <TextInput
                                    className="col-12 mb-3"
                                    label={item.value}
                                    onChange={(e) => {
                                      handleFieldChange(e, item.value);
                                    }}
                                    value={item.answer}
                                  />
                                  {profileFormSubmit &&
                                    (item.answer == "" ||
                                      item.answer == null ||
                                      item.answer == undefined) && (
                                      <div className="errorMsgText onboardingErrorMsg"
                                      >
                                        This field is required
                                      </div>
                                    )}
                                </div>
                              </>
                            );
                          })}
                    </div>
                  </div>
                </div>
              )}

              {profileConfig.profileFormPage === 3 && (
                <div className="profile-content-wrapper">
                  <div className="profile-body">
                    <div className="profile-form-body">
                      {userProfileDataLocal &&
                        userProfileDataLocal.userProfileMetaData.length > 0 &&
                        userProfileDataLocal.userProfileMetaData
                          .filter(
                            (x) => x.category == "Communities of Interest"
                          )
                          .map((item, index) => {
                            return (
                              <div key={`axzcas${index}`} className="more-about-me-field">
                                <label className="mb-2">{item.value}</label>
                                <div className="optionWrapper">
                                  {item.valueType === 2 &&
                                    JSON.parse(item.options).map((option, index) => {
                                      var isChecked =
                                        item.answer &&
                                        item.answer.includes(option);
                                      // return <><input type="checkbox" checked={isChecked} onChange={(e) => { handleCheckBoxChange(e, item, option, 0) }} className="custom-control-input" id={option} /> <span>{option}</span></>
                                      return (
                                        <Checkbox key={`alkmas${index}`}
                                          className="profile-checkbox-input"
                                          label={option}
                                          checked={isChecked}
                                          onChange={(e) =>
                                            handleCheckBoxChange(
                                              e,
                                              item,
                                              option,
                                              0
                                            )
                                          }
                                        />
                                      );
                                    })}

                                  {item.valueType === 3 &&
                                    JSON.parse(item.options).map(
                                      (grp, parentIndex) => {
                                        return (
                                          <div key={`phgas${parentIndex}`} className="optionGroup">
                                            {grp.map((option, index) => {
                                              var isChecked =
                                                item.answer &&
                                                item.answer.includes(option);
                                              return (
                                                <Checkbox key={`nbhacas${index}`}
                                                  className="profile-checkbox-input"
                                                  label={option}
                                                  checked={isChecked}
                                                  onChange={(e) =>
                                                    handleCheckBoxChange(
                                                      e,
                                                      item,
                                                      option,
                                                      parentIndex
                                                    )
                                                  }
                                                />
                                              );
                                            })}
                                          </div>
                                        );
                                      }
                                    )}
                                  {profileFormSubmit &&
                                    item.valueType === 2 &&
                                    (item.answer == null ||
                                      item.answer == "" ||
                                      item.answer == undefined) && (
                                      <div
                                        className="errorMsgText onboardingErrorMsg"
                                        style={{ width: "100%" }}
                                      >
                                        Atleast select one.
                                      </div>
                                    )}
                                  {profileFormSubmit &&
                                    item.valueType === 3 &&
                                    (item.answer == null ||
                                      item.answer == "" ||
                                      item.answer == undefined) && (
                                      <div
                                        className="errorMsgText onboardingErrorMsg"
                                        style={{ width: "100%" }}
                                      >
                                        Atleast select one.
                                      </div>
                                    )}
                                </div>
                              </div>
                            );
                          })}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {props.showArrow && (
              <div className="extra-profile">
                {profileConfig.profileFormPage > 1 && (
                  <button
                    className="arrow-btn back-arrow-btn"
                    onClick={() => {
                      dispatch(authSlice.actions.previousPage());
                    }}
                  ></button>
                )}

                {profileConfig.profileFormPage < 3 && (
                  <button
                    className="arrow-btn next-arrow-btn"
                    onClick={() => {
                      dispatch(authSlice.actions.nextPage());
                    }}
                  ></button>
                )}
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <CdxModal
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        onClose={() => setModalVisible(false)}
        noBorder={false}
      >
        <CdxModal.Header>Remove profile picture</CdxModal.Header>
        <CdxModal.Body>
          Are you sure?
        </CdxModal.Body>
        <CdxModal.Footer>
          <button className="cdx-btn" onClick={() => { setModalVisible(false); removeProfilePicture(); }}>Remove</button>
          <button className="cdx-btn" onClick={() => setModalVisible(false)}>Cancel</button>
        </CdxModal.Footer>
      </CdxModal>
    </>
  );
};

export default ProfileForm;
